const CONFIRMATION_OF_CLASS_BENEFICIARIES_DOCUMENT_TYPES = {
  MISSION_STATEMENT: {
    value: "mission_statement",
    readableName: "Mission Statement",
  },
  BENEFICIARY_DECLARATION: {
    value: "beneficiary_declaration",
    readableName: "Beneficiary Declaration",
  },
  TRUST_AGREEMENT: {
    value: "trust_agreement",
    readableName: "Trust Agreement",
  },
};

export const confirmationOfClassBeneficiariesDocumentTypesArray = Object.values(
  CONFIRMATION_OF_CLASS_BENEFICIARIES_DOCUMENT_TYPES,
);
